import { Theme, useTheme, VFlow } from 'bold-ui'
import { css } from 'emotion'
import { useServerTime } from 'hooks/useServerTime'
import React, { useMemo } from 'react'
import { calculateAge } from 'util/date/calculateAge'
import { CidadaoListagemSaudeMulherQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-saudeMulher'

import { RastreamentoAcompanhamentoIstPanel } from './RastreamentoAcompanhamentoIstPanel'
import { RastreamentoCancerColoUteroPanel } from './RastreamentoCancerColoUteroPanel'
import { RastreamentoCancerDeMamaPanel } from './RastreamentoCancerDeMamaPanel'
import { UltimaConsultaSaudeSexualReprodutivaPanel } from './UltimaConsultaSaudeSexualReprodutiva'

interface AcompanhamentoCondicaoSaudeMulherAccordionSectionProps {
  row: CidadaoListagemSaudeMulherQueryModel
}

export function AcompanhamentoCondicaoSaudeMulherAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeMulherAccordionSectionProps>
) {
  const theme = useTheme()
  const classes = useMemo(() => styles(theme), [theme])
  const { getServerTimeNow } = useServerTime()

  const { row } = props
  const saudeDaMulher = row.cidadao.cidadaoConsolidado?.saudeMulher
  const { years: idadeCidadao } = calculateAge(row.dataNascimentoCidadao, getServerTimeNow().getTime())

  return (
    <VFlow style={classes.grid} vSpacing={0}>
      <UltimaConsultaSaudeSexualReprodutivaPanel
        data={saudeDaMulher?.ultimaConsulta?.iniciadoEm}
        idadeCidadao={idadeCidadao}
      />
      <RastreamentoAcompanhamentoIstPanel
        hiv={saudeDaMulher?.hiv}
        sifilis={saudeDaMulher?.sifilis}
        hepatiteB={saudeDaMulher?.hepatiteB}
        hepatiteC={saudeDaMulher?.hepatiteC}
      />
      <RastreamentoCancerColoUteroPanel
        ultimaSolicitacao={saudeDaMulher?.ultimaSolicitacaoCancerColoUtero}
        ultimaAvaliacao={saudeDaMulher?.ultimaAvaliacaoCancerColoUtero}
        idadeCidadao={idadeCidadao}
      />
      <RastreamentoCancerDeMamaPanel
        ultimaAvaliacao={saudeDaMulher?.ultimaAvaliacaoCancerMama}
        ultimaRealizacao={saudeDaMulher?.ultimaRealizacaoCancerMama}
        ultimaSolicitacao={saudeDaMulher?.ultimaSolicitacaoCancerMama}
        idadeCidadao={idadeCidadao}
      />
    </VFlow>
  )
}

const styles = (theme: Theme) => ({
  grid: css`
    & > div {
      padding: 1rem 0;
      border-bottom: 1px solid ${theme.pallete.divider};
      &:first-child {
        padding-top: 0.75rem;
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  `,
})
